import { render, staticRenderFns } from "./ScrollAnimatedTitle.vue?vue&type=template&id=a6bab154&"
import script from "./ScrollAnimatedTitle.vue?vue&type=script&lang=ts&"
export * from "./ScrollAnimatedTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports